/* eslint-disable */
/* tslint:disable */
import { createContext } from 'react'
import { ApolloApiClientV1 } from './apollo'
import AssignmentRulesets from './assignment-rulesets'
import Audit from './audit'
import Auth from './auth'
import Billing from './billing'
import ChatPlatformBuilder from './chat-platform-builder'
import ChatPlatformChat from './chat-platform-chat'
import ChatPlatformPiperAi from './chat-platform-piper-ai'
import ChiliCrm from './chili-crm'
import ConciergeFire from './concierge-fire'
import CustomizationSettings from './customization-settings'
import DistributedRecordsReporting from './distributed-records-reporting'
import Distribution from './distribution'
import Distro from './distro'
import DynamicTags from './dynamic-tags'
import EdgeFire from './edge-fire'
import { EnrichmentApiClientV1 } from './enrichment'
import ExternalCalendar, {
  ExternalCalendarApiClientV2,
  ExternalCalendarApiClientV3,
} from './external-calendar'
import FireRouter from './firerouter'
import Gong, { GongApiClientV2 } from './gong'
import GoogleAuthentication, {
  GoogleAuthenticationApiClientV2,
  GoogleAuthenticationApiClientV3,
} from './google-authentication'
import Gotomeeting from './gotomeeting'
import Handoff from './handoff'
import { ApiConfig } from './http-client-base'
import Hubspot from './hubspot'
import IntegrationNotifications, {
  IntegrationNotificationsApiClientV2,
} from './integration-notifications'
import Kosmotime from './kosmotime'
import { LeadiqApiClientV1 } from './leadiq'
import { LushaApiClientV1 } from './lusha'
import { MeetingTypesApiClientV1, MeetingTypesApiClientV2 } from './meeting-types'
import Meetings, { MeetingsApiClientV2 } from './meetings'
import { MeetingsApiApiClientV1, MeetingsApiApiClientV3 } from './meetings-api'
import MeetingsCrmApiClientV1 from './meetings-crm'
import { MeetingsPlatformApiClientV1, MeetingsPlatformApiClientV3 } from './meetings-platform'
import MicrosoftAuthentication, {
  MicrosoftAuthenticationApiClientV3,
} from './microsoft-authentication'
import MicrosoftTeams from './microsoft-teams'
import Notifications from './notifications'
import OutreachApiClient from './outreach'
import PhoneCaller from './phone-caller'
import { ReportingAgentApiClientV1 } from './reporting-agent'
import Ringcentral from './ringcentral'
import Rules, { RulesApiClientV2 } from './rules'
import Salesforce, { SalesforceApiClientV2 } from './salesforce'
import SalesloftApiClient from './salesloft'
import services from './services.json'
import Slack from './slack'
import TeamScheduling, { TeamSchedulingApiClientV2, TeamSchedulingApiClientV3 } from './team-scheduling'
import Teams from './teams'
import Tenant from './tenant'
import Twilio from './twilio'
import UiMetadata from './ui-metadata'
import {
  UserAvailabilityApiClientV1,
  UserAvailabilityApiClientV2,
  UserAvailabilityApiClientV3,
} from './user-availability'
import Webex from './webex'
import Workspace, { WorkspaceApiClientV2, WorkspaceApiClientV3 } from './workspace'
import Zapier from './zapier'
import Zoom from './zoom'
import ZoomInfoApiClient from './zoominfo'
import SpamCheckerApiClient from './spam-checker'
import { OrchestratorApiClientV1 } from './orchestrator'
import { MeetingPrepApiClientV1 } from './meeting-prep'
import ResourceScheduler from './resource-scheduler'

type ToCamelCase<T extends string> = T extends `${infer S}-${infer Rest}`
  ? `${S}${Capitalize<ToCamelCase<Rest>>}`
  : T

type RemoveServicePostfix<T extends string> = T extends `${infer S}-service` ? S : T

type JsonKeys =
  | keyof typeof services
  | 'rulesV2'
  | 'workspaceV2'
  | 'workspaceV3'
  | 'gongV2'
  | 'meetingsPlatform'
  | 'meetingsApiV3'
  | 'meetingsPlatformV3'
  | 'meetingTypesV2'
  | 'meetingsV2'
  | 'integrationNotificationsV2'
  | 'salesforceV2'
  | 'userAvailabilityV2'
  | 'userAvailabilityV3'
  | 'googleAuthenticationV2'
  | 'googleAuthenticationV3'
  | 'externalCalendarV2'
  | 'externalCalendarV3'
  | 'microsoftAuthenticationV3'
  | 'teamSchedulingV2'
  | 'teamSchedulingV3'
type DashedServices = RemoveServicePostfix<JsonKeys>
type Services = ToCamelCase<DashedServices>
type UntypedClients = Record<Services, any>

export const createClients = (apiConfig: ApiConfig) =>
  ({
    apollo: new ApolloApiClientV1(apiConfig),
    assignmentRulesets: new AssignmentRulesets(apiConfig),
    audit: new Audit(apiConfig),
    auth: new Auth(apiConfig),
    billing: new Billing(apiConfig),
    chatPlatformBuilder: new ChatPlatformBuilder(apiConfig),
    chatPlatformChat: new ChatPlatformChat(apiConfig),
    chatPlatformPiperAi: new ChatPlatformPiperAi(apiConfig),
    chiliCrm: new ChiliCrm(apiConfig),
    conciergeFire: new ConciergeFire(apiConfig),
    distributedRecordsReporting: new DistributedRecordsReporting(apiConfig),
    distribution: new Distribution(apiConfig),
    distro: new Distro(apiConfig),
    dynamicTags: new DynamicTags(apiConfig),
    enrichment: new EnrichmentApiClientV1(apiConfig),
    externalCalendar: new ExternalCalendar(apiConfig),
    leadiq: new LeadiqApiClientV1(apiConfig),
    /** @deprecated This client is deprecated. Please use the new meetingsApi instead. */
    meetingsPlatform: new MeetingsPlatformApiClientV1(apiConfig),
    /** @deprecated This client is deprecated. Please use the new meetingsApiV3 instead. */
    meetingsPlatformV3: new MeetingsPlatformApiClientV3(apiConfig),
    externalCalendarV2: new ExternalCalendarApiClientV2(apiConfig),
    externalCalendarV3: new ExternalCalendarApiClientV3(apiConfig),
    firerouter: new FireRouter(apiConfig),
    gong: new Gong(apiConfig),
    gongV2: new GongApiClientV2(apiConfig),
    customizationSettings: new CustomizationSettings(apiConfig),
    googleAuthentication: new GoogleAuthentication(apiConfig),
    googleAuthenticationV2: new GoogleAuthenticationApiClientV2(apiConfig),
    googleAuthenticationV3: new GoogleAuthenticationApiClientV3(apiConfig),
    handoff: new Handoff(apiConfig),
    hubspot: new Hubspot(apiConfig),
    integrationNotifications: new IntegrationNotifications(apiConfig),
    integrationNotificationsV2: new IntegrationNotificationsApiClientV2(apiConfig),
    kosmotime: new Kosmotime(apiConfig),
    lusha: new LushaApiClientV1(apiConfig),
    meetingPrep: new MeetingPrepApiClientV1(apiConfig),
    meetingTypes: new MeetingTypesApiClientV1(apiConfig),
    meetingTypesV2: new MeetingTypesApiClientV2(apiConfig),
    meetings: new Meetings(apiConfig),
    meetingsV2: new MeetingsApiClientV2(apiConfig),
    meetingsCrm: new MeetingsCrmApiClientV1(apiConfig),
    meetingsApi: new MeetingsApiApiClientV1(apiConfig),
    meetingsApiV3: new MeetingsApiApiClientV3(apiConfig),
    microsoftAuthentication: new MicrosoftAuthentication(apiConfig),
    microsoftAuthenticationV3: new MicrosoftAuthenticationApiClientV3(apiConfig),
    notifications: new Notifications(apiConfig),
    orchestrator: new OrchestratorApiClientV1(apiConfig),
    phoneCaller: new PhoneCaller(apiConfig),
    reportingAgent: new ReportingAgentApiClientV1(apiConfig),
    rules: new Rules(apiConfig),
    rulesV2: new RulesApiClientV2(apiConfig),
    salesforce: new Salesforce(apiConfig),
    salesforceV2: new SalesforceApiClientV2(apiConfig),
    slack: new Slack(apiConfig),
    teamScheduling: new TeamScheduling(apiConfig),
    teamSchedulingV2: new TeamSchedulingApiClientV2(apiConfig),
    teamSchedulingV3: new TeamSchedulingApiClientV3(apiConfig),
    teams: new Teams(apiConfig),
    tenant: new Tenant(apiConfig),
    twilio: new Twilio(apiConfig),
    uiMetadata: new UiMetadata(apiConfig),
    userAvailability: new UserAvailabilityApiClientV1(apiConfig),
    userAvailabilityV2: new UserAvailabilityApiClientV2(apiConfig),
    userAvailabilityV3: new UserAvailabilityApiClientV3(apiConfig),
    workspace: new Workspace(apiConfig),
    workspaceV2: new WorkspaceApiClientV2(apiConfig),
    workspaceV3: new WorkspaceApiClientV3(apiConfig),
    zapier: new Zapier(apiConfig),
    zoom: new Zoom(apiConfig),
    outreach: new OutreachApiClient(apiConfig),
    salesloft: new SalesloftApiClient(apiConfig),
    ringcentral: new Ringcentral(apiConfig),
    gotomeeting: new Gotomeeting(apiConfig),
    webex: new Webex(apiConfig),
    edgeFire: new EdgeFire(apiConfig),
    microsoftTeams: new MicrosoftTeams(apiConfig),
    zoominfo: new ZoomInfoApiClient(apiConfig),
    spamChecker: new SpamCheckerApiClient(apiConfig),
    resourceScheduler: new ResourceScheduler(apiConfig),
  }) satisfies UntypedClients

export type Clients = ReturnType<typeof createClients>

// We declare the context in a separate file to avoid duplication when trying to bundle
// the tsx file. More details on https://github.com/Chili-Piper/chilical/pull/1040#discussion_r1310768136
export const ApiClientContext = createContext<Partial<Clients> | null>(null)
